import { openDirectivesSettings } from './messageHandlers/directiveMessageHandlers';
import { chatReady, appLoadedFromCache } from './messageHandlers/coreMessageHandlers';
import type { MailboxInfo } from 'owa-client-types';

/**
 * The function signature of BizChat handlers.
 * Required parameters are those shared both when OWA is hosting BizChat and when BizChat is hosting OWA.
 * Optional parameters are only applicable when OWA is hosting BizChat.
 */
type BizChatMessageHandler = (
    /** Payload sent from frame for host to handle */
    payload: any,
    /** The postMessage callback to communicate with the frame */
    postMessageToFrame: (message: unknown) => void,
    /** The mailbox to which the CustomMessageService belongs to */
    mailboxInfo: MailboxInfo,
    /** The host window of the BizChat frame. */
    targetWindow: Window | undefined,
    /** Whether BizChat is being hosted in full screen */
    isImmersiveBizchat?: boolean
) => Promise<unknown>;

const defaultHandlers: Record<string, BizChatMessageHandler> = {
    openDirectivesSettings,
    ChatReady: chatReady,
    appLoadedFromCache,
};

export let bizChatHandlers: Record<string, BizChatMessageHandler> = { ...defaultHandlers };

export function setBizChatHandlers(newHandlers: Record<string, BizChatMessageHandler>): void {
    bizChatHandlers = {
        ...defaultHandlers,
        ...newHandlers,
    };
}
